import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function PauseIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'SecondaryPendingHover', secondaryColor = 'Grey7', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    const secondaryFillColor = themeContext.colors[secondaryColor];
    return (_jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("rect", { x: "2", y: "2", width: "20", height: "20", fill: primaryFillColor }), _jsx("path", { d: "M14.5 7H13V12.25V17.5H14.5V7Z", fill: secondaryFillColor }), _jsx("path", { d: "M10.5 7H9V12.25V17.5H10.5V7Z", fill: secondaryFillColor })] }));
}
//# sourceMappingURL=Pause.js.map